import React, { useEffect, useRef, useState } from 'react'
import { InnerHeader } from '../../Components/inner-header/InnerHeader1'
import { SubHeader } from '../../Components/sub-header/SubHeader'
import { Innerfooter } from '../../Components/inner-footer/Innerfooter1'
import { DashboardToSectionDetails } from '../../Components/CommanPages/DashboardToSectionDetails'
import { Modal, Spinner } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { errorAlert, successAlert } from '../../../Static_Services/Alertmsg'
import { API_cardGet, API_clover_buy_now_single, API_pay_at_desk, API_update_cart, ExpiryCheck } from '../../../Static_Services/Staff_Services'
import Swal from 'sweetalert2'

const getProductPrice = (amount, tax) => {
  if (tax === 0) {
    return 0;
  } else {
    const taxAmount = (+tax / 100) * +amount;
    return taxAmount;
  }
}

export const ProductPurchase = () => {
  const [loder, setLoder] = useState(false);
  const navigate = useNavigate();
  const [businessDetail, setBusinessDetail] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const location = useLocation();
  const [productDetail, setProductDetail] = useState();
  const [productCount, setProductCount] = useState(1);
  const [customerData, setCustomerData] = useState();
  const [savecard, setSavecard] = useState(0);
  const [cardType, setCardType] = useState();
  const [paymentval, setPaymentval] = useState();
  const [productTax, setProductTax] = useState(0);
  const [modalshow, setModalshow] = useState(false);

  const [showCodeModel, setShowCodeModel] = useState({ visible: false, list: [] });
  const [dCodeId, setDCodeId] = useState('');
  const [dCodeName, setDCodeName] = useState();
  const [dCode, setDCode] = useState();



  useEffect(() => {
    if (JSON.parse(localStorage.getItem('w_BusinessDetail'))) {
      setBusinessDetail(JSON.parse(localStorage.getItem('w_BusinessDetail')))
    }
    if (JSON.parse(localStorage.getItem('w_loginDetail'))) {
      setUserInfo(JSON.parse(localStorage.getItem('w_loginDetail')));
    }
    const navData = location.state;
    if (navData.Detail) {
      localStorage.setItem('w_ProductDetail', JSON.stringify(navData.Detail));
    }
    if (JSON.parse(localStorage.getItem('w_ProductDetail'))) {
      setProductDetail(JSON.parse(localStorage.getItem('w_ProductDetail')))
    }
  }, [])


  const updateCount = (value, data) => {
    if (value == '+') {
      if (productCount < productDetail.product_quantity) {
        const updatedCount = productCount + 1;
        setProductCount(updatedCount);
        const datas = { quantity: updatedCount, product_id: data.product_id };
        updateCartDetail(datas);
      } else {
        errorAlert('Product Not available');
        return false;
      }
    } else {
      if (productCount > 1) {
        const updatedCount = productCount - 1;
        setProductCount(updatedCount);
        const datas = { quantity: updatedCount, product_id: data.product_id };
        updateCartDetail(datas);
      } else {
        errorAlert('Minimum Quantity is 1')
        return false;
      }
    }
  }

  const updateCartDetail = async (data) => {
    setLoder(true);
    const detail = { "cart_id": "", "quantity": data.quantity, "product_id": data.product_id };
    const resp = await API_update_cart(detail);

    if (resp) {
      const response = resp.data;
      successAlert(response.message);
      const prd = productDetail;
      prd.product_price = response.data.total_amount;
      prd.product_tax_price = response.data.tax;
      prd.product_total_price = response.data.grand_total;
      prd.tax1_rate = response.data.tax1_rate;
      prd.tax2_rate = response.data.tax2_rate;
      setProductDetail(prd);
      setLoder(false);
    } else {
      setLoder(false);
    }
  }



  const onApplyDiscount = async (data) => {
    if (!data) return;
    setShowCodeModel({ visible: false });


    const prAmount = parseFloat(productDetail?.product_price || 0).toFixed(2);
    const percentage = parseFloat(data?.amount || 0).toFixed(2);
    const dis = ((prAmount * percentage) / 100).toFixed(2);
    const discountAmount = parseFloat(dis).toFixed(2);

    const adj_price = (parseFloat(prAmount) - parseFloat(discountAmount));
    const finalTax1 = getProductPrice(adj_price, productDetail?.tax1_rate);
    const finalTax2 = getProductPrice(adj_price, productDetail?.tax2_rate);
    const finalTotal = ((adj_price + ((parseFloat(finalTax1) + parseFloat(finalTax2)))));
    const totalTax = (parseFloat(finalTax1) + parseFloat(finalTax2));

    if (discountAmount > prAmount) {
      errorAlert("Discount amount cannot exceed the base workshop fee");
      return;
    }
    if (discountAmount < 0) {
      errorAlert("Discount cannot be a negative value");
      return;
    }

    const prd = productDetail;
    prd.product_price = prAmount;
    prd.product_tax_price = totalTax;
    prd.product_total_price = parseFloat(finalTotal).toFixed(2);
    prd.tax1_rate = productDetail?.tax1_rate;
    prd.tax2_rate = productDetail?.tax2_rate;
    prd.discount = parseFloat(discountAmount).toFixed(2);
    setProductDetail(prd);
    setDCodeId(data.discount_code_id);

    Swal.fire({
      html: `
                         <div>
                          <img src="assets/gif/congratulation.gif" width="100%" />
                          <h4 style="color:#00ff99;
                           position: absolute;
                          top: 68%;
                          left:0;
                          right:0;
                            font-weight:700;
                          ">COUPON APPLIED!</h4>
                          <p style="color:#fff;
                          position: absolute;
                          top: 80%;
                          left:0;
                          right:0;
                          font-weight:700;
                          ">You saved ₹${discountAmount}</p>
                        </div>            
                      `,
      background: 'none',
      showConfirmButton: false,
      timer: 3000,
      showClass: {
        popup: 'animate__animated animate__bounceIn'
      }
    });

  }

  const payment = () => {
    //   var expired = ExpiryCheck(paymentCard.value.expiry);
    //   if(expired)  {
    //     this.paymentCard.value.expiry_month = expired[0];
    //     this.paymentCard.value.expiry_year = expired[1];
    //   }  else{
    //     return false;
    //   }
    //   this.submitted = true;

    //   let card = this.paymentCard;
    //   if(card.valid){
    //     this.loading = true;    
    //     var detail = {
    //       "service_type":"3",
    //       "service_id":this.ProductDetail.product_id,
    //       "quantity":this.ProductCount,
    //       "grand_total":this.ProductDetail.product_total_price,
    //       "slot_date":"",
    //       "slot_time_id":"",
    //       "token": this.paymentCard.value.token ,
    //       "savecard": this.savecard,
    //       "card_id" : '',
    //       "business_id":this.businessDetail.business_id,
    //       "number": this.paymentCard.value.card_number,
    //       "expiry_month": this.paymentCard.value.expiry_month,
    //       "expiry_year": this.paymentCard.value.expiry_year,
    //       "cvd": this.paymentCard.value.cvv_no,
    //       "country_code":"",
    //       "customer_name":this.paymentCard.value.card_holder_name,
    //     };
    //    //var url = 'superadmin/webservices/api/buy_now';
    //     // var url = 'superadmin/webservices/api/clover_buy_now';   
    //     var url = 'superadmin/webservices/api/clover_buy_now_single';    
    //     this.commonservice.PostApi(detail,url).subscribe(((response : any) => {
    //       if(response.status == 1){
    //         this.commonservice.successAlert(response.message);
    //         this.loading = false;
    //         this.submitted = false;
    //         this.paymentCard.reset();
    //         this.route.navigate(['/product']);
    //       } else{
    //         this.commonservice.dangerAlert(response.message);
    //         this.loading = false;
    //       }
    //     })) 

    // } else{
    //   this.loading = false;
    //   return false;
    // }
  }

  const savePayment = async (card) => {
    setLoder(true);
    const detail = {
      "service_type": "3",
      "service_id": productDetail.product_id,
      "quantity": productCount,
      "grand_total": productDetail.product_total_price,
      "slot_date": "",
      "slot_time_id": "",
      "token": card.card_token,
      "savecard": 0,
      "card_id": card.card_id,
      "business_id": businessDetail.business_id,
      "country_code": "",
      "discount_code": dCodeId,
      "discount_amount": productDetail?.discount ?? 0,
      "d_code_name": dCodeName ?? '',
    };
    const resp = await API_clover_buy_now_single(detail);
    if (resp) {
      const response = resp.data;
      successAlert(response.message);
      setLoder(false);
      navigate('/my-purchase');
    } else {
      setLoder(false);
    }
  }

  const getSaveCardDetail = async (userID, businessID) => {
    setLoder(true);
    var detail = { "userid": userID, 'business_id': businessID };
    const resp = await API_cardGet(detail);
    if (resp) {
      const response = resp.data;
      response.data.map((el) => {
        el.checked = false;
      })
      setCustomerData(response.data);
      setLoder(false);
    } else {
      setLoder(false);
    }
  }



  const getCardType = (event) => {
    setCardType(event.target.id);
    if (customerData && customerData.length > 0) {
      customerData?.map((el) => {
        if (el.card_id == cardType) {
          el.checked = event.target.checked;
        }
      })
    }
  }

  const PayAtStudio = async () => {
    setLoder(true);
    const detail = {
      "service_type": "3",
      "service_id": productDetail.product_id,
      "quantity": productCount,
      "slot_date": "",
      "slot_time_id": "",
      "business_id": businessDetail.business_id,
      "amount": productDetail.product_price,
      "tax": productDetail.product_tax_price,
      "instructor_id": ""
    };
    const resp = await API_pay_at_desk(detail);
    if (resp) {
      const response = resp.data;
      successAlert(response.message);
      setLoder(false);
      navigate('/my-purchase');
    } else {
      setLoder(false);
    }
  }

  const redirectUrl = (url, Id) => {
    navigate(url, { state: { Id: Id } });
  }

  useEffect(() => {
    if (businessDetail && businessDetail?.business_id && userInfo && userInfo?.id) {
      const newUserId = userInfo?.id;
      const newBusinessId = businessDetail?.business_id;
      getSaveCardDetail(newUserId, newBusinessId);
    }
  }, [businessDetail, userInfo])

  const [carderror, setCarderror] = useState({ name: "", crnumber: "", dates: "", cvv: "" });
  const [cardData, setCardData] = useState({ name: "", crnumber: "", dates: "", cvv: "" });
  const [expiryDate, setExpiryDate] = useState();
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      if (inputValue.endsWith('/')) {
        setExpiryDate(inputValue.slice(0, -1));
      } else { setExpiryDate(inputValue); }
    } else {
      if (inputValue.length === 2 && inputValue.charAt(2) !== '/') {
        setExpiryDate(inputValue + '/');
      } else if (inputValue.length === 8) { return; } else { setExpiryDate(inputValue); }
    }
  };

  const SavecardHandeler = (event) => {
    if (event.target.checked == true) {
      setSavecard(1);
    }
    else { setSavecard(0) }
  }

  const CardInputChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = value.replace(/^\s+/g, '');
    setCardData((pre) => ({ ...pre, [name]: cleanedValue }));
    setCarderror((pre) => ({ ...pre, [name]: "" }));
  }


  const paymentHandler = async (prDetail) => {

    let isValid = 1;
    let expiry_month = '';
    let expiry_year = '';
    let expired = '';

    if (expiryDate) {
      expired = ExpiryCheck(expiryDate);
    }
    if (expired) {
      expiry_month = expired[0];
      expiry_year = expired[1];
    } else {
      setCarderror((pre) => ({ ...pre, dates: "* Valid Till is required" }));
      isValid = 2;
    }
    if (!cardData.name) { setCarderror((pre) => ({ ...pre, name: "* Card Holder Name is required" })); isValid = 3; };
    if (!cardData.crnumber) {
      setCarderror((pre) => ({ ...pre, crnumber: "* Card Number is required" }))
      isValid = 4;
    };
    if (!cardData.cvv) {
      setCarderror((pre) => ({ ...pre, cvv: "* CVV is required" }));
      isValid = 5;
    };
    if (isValid === 1) {
      setLoder(true);
      const detail = {
        "service_type": "3",
        "service_id": prDetail.product_id,
        "quantity": productCount,
        "grand_total": prDetail.product_total_price,
        "slot_date": "",
        "slot_time_id": "",
        "token": '',
        "savecard": savecard,
        "card_id": '',
        "business_id": businessDetail.business_id,
        "number": cardData.crnumber,
        "expiry_month": expiry_month,
        "expiry_year": expiry_year,
        "cvd": cardData.cvv,
        "country_code": "",
        "customer_name": cardData.name,
        "discount_code": dCodeId,
        "discount_amount": prDetail?.discount ?? 0,
        "d_code_name": dCodeName ?? '',
      };
      const resp = await API_clover_buy_now_single(detail);
      if (resp) {
        const response = resp.data;
        setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
        successAlert(response.message);
        setLoder(false);
        navigate('/my-purchase');
        // window.history.back();
      } else {
        setCardData({ name: "", crnumber: "", dates: "", cvv: "" });
        setLoder(false);
      }
    } else {
      setLoder(false);
      return false;
    }
  }



  const onApplyDiscountNew = async (discountList) => {
    if (!discountList) return;

    if (!dCode) {
      errorAlert("Please enter discount code");
      return;
    }
    const found = discountList.find(
      (d) =>
        d.code_name.toLowerCase().trim() ===
        dCode.toLowerCase().trim()
    );

    if (!found) {
      errorAlert("Invalid or already applied discount code.");
      return;
    }

    const prAmount = Number(productDetail.product_total_price || 0);
    const percentage = Number(found?.amount || 0);
    const dis = ((prAmount * percentage) / 100).toFixed(2);
    const discountAmount = Number(dis);
    const after_discount = (parseFloat(prAmount) - parseFloat(discountAmount));


    if (discountAmount > prAmount) {
      errorAlert("Discount amount cannot exceed the base workshop fee");
      return;
    }
    if (discountAmount < 0) {
      errorAlert("Discount cannot be a negative value");
      return;
    }
    const prd = { ...productDetail };
    prd.product_total_price = after_discount;
    prd.discount = discountAmount;
    setProductDetail(prd);
    setDCodeId(found.discount_code_id);
    setDCodeName(found.code_name);
    successAlert("Coupon applied successfully");
  }

  return (
    <>

      {loder ? <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> <span className="visually-hidden">Loading...</span>  </Spinner> </div> : ""}
      <InnerHeader />
      <div className="body-grey">

        <div class="studio-details">
          <div class="container">
            <DashboardToSectionDetails />
            <div class="pb-5">
              <div class="row">
                <div class="col-6 text-left">
                  <h4 class="title black-color text-capitalize"> products details </h4>
                </div>
                <div class=" col-6 text-right mb-3">
                  <button type="button" class="btn btn-blue-grad px-2 text-capitalize" onClick={() => window.history.back()} >Back </button>
                </div>
              </div>
              {/* <!-- End of Heading --> */}

              <div class="s-d-appoint-block">
                <div class="row">
                  <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                    <div class="client-buy-input border-radius6 box-shadow1 white-bg p-4">
                      <div class="row">
                        <div class="col-12 mb-4">
                          <div class="white-bg border-radius6 box-shadow1 p-4">
                            <div class="row">
                              <div class="col-3 pr-0">
                                <div class="border-radius6 box-shadow1 p-3">
                                  <img src={productDetail && productDetail.product_images[0] && productDetail.product_images[0].image_name ? productDetail.product_images[0].image_name : businessDetail.logo} alt='' class="img-fluid w-10" />
                                </div>
                              </div>
                              <div class="col-9">
                                <div class="">
                                  <h5 class="heading-titlenew black-color mb-0"> {productDetail && productDetail.product_name} </h5>
                                  {productDetail && productDetail.product_description.length <= 40 &&
                                    <p class="brand-color3 font-12 my-2">{productDetail.product_description}</p>}
                                  {productDetail && productDetail.product_description.length > 40 &&
                                    <p class="brand-color3 font-12 my-2 paratitle">
                                      {productDetail.product_description} </p>}

                                  <h5 class="heading-titlenew brand-color3 mb-0">Amount : {businessDetail.currency} {productDetail && productDetail.product_price} </h5>
                                  {productDetail &&
                                    <div class="pt-1 w-50">
                                      <div id="input_div" class="counter-box d-flex align-items-center">

                                        <input type="button" value="+" id="plus"
                                          class="brand-color2 font-w-600 font-28 mr-1 functionplus"
                                          onClick={() => updateCount('+', productDetail)}
                                          style={{ fontFamily: "Arial" }} />

                                        <input type="text" id="count" class="inputWidth brand-color1 flex-fill" value={productCount}
                                          name="ProductCount" />
                                        <input type="button" value="-" id="moins"
                                          class="brand-color2 font-w-600 font-28 functionminus"
                                          onClick={() => updateCount('-', productDetail)}
                                          style={{ fontFamily: "Arial" }} />
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!paymentval &&
                    <div class="col-12 col-lg-6 mt-5 mt-lg-0">
                      <div class="s-d-appoint-block-right border-radius6 box-shadow1 white-bg">
                        <div class="px-3 py-3 text-left light-bg border-t-lr-6">
                          <h5 class="title black-color font-w-100 text-capitalize font-16 mb-0"> payment details </h5>
                        </div>
                        <div class="px-3 pt-4 pb-4 border-bottom">
                          <div class="row mb-2">
                            <div class="col-6 text-left">
                              <p class="black-color font-w-100 font-18"> Price(ProductCount Item) </p>
                            </div>
                            <div class="col-6 text-right">
                              <p class="black-color font-w-100 font-18"> {businessDetail.currency} {productDetail && productDetail.product_price} </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6 text-left">
                              <p class="black-color font-w-100 font-18"> Tax 1 </p>
                            </div>
                            <div class="col-6 text-right">
                              <p class="black-color font-w-100 font-18"> {businessDetail.currency} {productDetail && productDetail.tax1_rate} </p>
                            </div>
                            <div class="col-6 text-left">
                              <p class="black-color font-w-100 font-18"> Tax 2 </p>
                            </div>
                            <div class="col-6 text-right">
                              <p class="black-color font-w-100 font-18"> {businessDetail.currency} {productDetail && productDetail.tax2_rate} </p>
                            </div>
                          </div>
                        </div>
                        <div class="px-3 pt-4 pb-3 border-bottom">
                          <div class="row pt-3 mb-2">
                            <div class="col-6 text-left">
                              <p class="title black-color font-w-100 font-18 mb-0"> Amount Payable </p>
                            </div>
                            <div class="col-6 text-right">
                              <p class="title black-color font-w-100 font-18 mb-0"> {businessDetail?.currency ?? "$ "} {productDetail && parseFloat(productDetail.product_total_price).toFixed(2)} </p>
                            </div>
                          </div>
                        </div>
                        <div class="px-3 py-5 text-center">
                          <button data-toggle="modal" data-target="#clientCheckOut" type="button" onClick={() => setModalshow(true)}
                            class="btn btn-blue-grad px-4 w-50 text-capitalize mb-0 mb-md-5"> checkout </button>
                        </div>
                      </div>
                    </div>
                  }

                  {paymentval &&
                    <div class="col-12 col-lg-6 mt-5 mt-lg-0">
                      <div class="client-buy-process border-radius6 box-shadow1 white-bg" >
                        <div class="p-3 text-left light-bg border-t-lr-6">
                          <h5 class="title black-color font-w-100 text-capitalize font-16 mb-0"> credit card / debit card </h5>
                        </div>
                        <div class="px-3 pt-4 pb-3 border-bottom">

                          <div className="row mt-3 px-3 pb-2 mb-3 border-bottom">
                            <div className="col-4 text-left p-0">
                              <p style={{ fontWeight: '600', margin: 'auto' }}>Discount Code</p>
                            </div>
                            <div className="col-8">
                              <div className="row">
                                <div className="col-8 discount-box">
                                  <div className="inputNumber" style={{ padding: '0px 10px' }}>
                                    <input name='coupon_code'
                                      style={{
                                        width: '190px',
                                        padding: '0.1rem 0.4rem',
                                        fontSize: '12px',
                                      }}
                                      value={dCode}
                                      onChange={(event) => setDCode(event.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className='col-4 text-right p-0'>
                                  <button
                                    className="discount-button"
                                    onClick={() => onApplyDiscountNew(productDetail?.discount_code)}

                                  >Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>




                          {/* <div className='col-12 p-0 m-0'>
                            <div className="w-100 mt-4 d-flex justify-content-between">
                              <h6 style={{ fontWeight: '600' }}>Coupon Code</h6>
                              <button
                                className="discount-button"
                                onClick={() => setShowCodeModel({ visible: true, list: productDetail?.discount_code })}
                              >Apply
                              </button>
                            </div>
                          </div> */}


                          {productDetail?.discount &&
                            <div class="row mb-2">
                              <div class="col-6 text-left">
                                <p class="title black-color font-w-100 font-18 mb-0"> Discounted Amount </p>
                              </div>
                              <div class="col-6 text-right">
                                <p class="title black-color font-w-100 font-18 mb-0"> - {businessDetail?.currency ?? "$ "} {productDetail && parseFloat(productDetail?.discount).toFixed(2)} </p>
                              </div>
                            </div>
                          }

                          <div class="row mb-2">
                            <div class="col-6 text-left">
                              <p class="title black-color font-w-100 font-18 mb-0"> Amount Payable </p>
                            </div>
                            <div class="col-6 text-right">
                              <p class="title black-color font-w-100 font-18 mb-0"> {businessDetail?.currency ?? "$ "} {productDetail && parseFloat(productDetail.product_total_price).toFixed(2)} </p>
                            </div>
                          </div>

                        </div>
                        <div class="client-payment-input border-radius6 box-shadow1 white-bg p-4">
                          <div class="row">
                            {customerData && customerData.map((cardsave) => (
                              <div class="col-12 mb-3">
                                {cardsave.length != 0 &&
                                  <div class="client-card-img white-bg border-radius6 box-shadow1">
                                    <label class="select-card select-card-img select-card-cvv mb-2">
                                      {(cardsave.card_type == 'VISA' || cardsave.card_type == 'visa') &&
                                        <img src="clientassets/img/visa_card.png" alt='' class="img-fluid payment_img" />}
                                      {cardsave.card_type == 'MC' &&
                                        <img src="clientassets/img/master_card.png" alt='' class="img-fluid payment_img" />}
                                      {cardsave.card_type == 'AM' &&
                                        <img src="clientassets/img/american_express.png" alt='' class="img-fluid payment_img" />}
                                      <p class="mb-0 font-12 dark-color mt-2">{cardsave.number} </p>
                                      <h5 class="mb-0 font-12 dark-color mt-2">Valid Till(MM/YYYY) </h5>
                                      <p class="mb-0 font-12 dark-color mt-2">{cardsave.expiry_month} / {cardsave.expiry_year}</p>

                                      <input type="radio" checked={cardsave.card_id == cardType} name="radio"
                                        id={cardsave.card_id}
                                        value={cardsave.card_id}
                                        // [(ngModel)]="cardType" [ngModelOptions]="{standalone: true}"
                                        onChange={(e) => getCardType(e)}
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    {cardType == cardsave.card_id &&
                                      <form >
                                        <div class="text-center d-flex flex-wrap">
                                          <button type="button" class="btn btn-blue-grad px-4 w-100 text-capitalize mb-0 mb-md-3 ml-5"
                                            onClick={() => savePayment(cardsave)}
                                          > Pay Now </button>
                                        </div>
                                      </form>
                                    }
                                  </div>
                                }
                              </div>
                            ))}
                            <div class="col-12 mb-3">
                              <div class="white-bg border-radius6 box-shadow1">
                                <label class="select-card"> New Card
                                  <input type="radio" checked={cardType == "new"} name="radio" id="new" value="new"
                                    onChange={(e) => getCardType(e)}
                                  />
                                  <span class="checkmark"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        {cardType == 'new' &&
                          <form>
                            <div class="row py-4 px-3">
                              {/* Card Name */}
                              <div className="col-12 col-sm-6">
                                <div className="form-group">
                                  <p className="brand-color3 text-left font-14 mb-2"> Name On Card </p>
                                  <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name='name'
                                    placeholder="Sophie Joe"
                                    value={cardData.name}
                                    onChange={CardInputChange}
                                  />
                                  <small className="text-danger">{carderror.name}</small>
                                </div>
                              </div>
                              {/* <!-- Card Number --> */}
                              <div className="col-12 col-sm-6">
                                <div className="form-group client-buy-input-cardno">
                                  <p className="brand-color3 text-left font-14 mb-2"> Card Number </p>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    placeholder="4121 4411 3131 8554"
                                    name='crnumber'
                                    value={cardData.crnumber}
                                    onChange={CardInputChange}
                                    maxLength={19}
                                  />
                                  <small className="text-danger">{carderror.crnumber}</small>
                                </div>
                              </div>

                              {/* <!-- Exp... Dates --> */}
                              <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                  <p className="brand-color3 text-left font-14 mb-2"> Valid Till </p>
                                  <input
                                    type="text"
                                    name={'dates'}
                                    className="form-control"
                                    placeholder="MM/YYYY"
                                    value={expiryDate}
                                    onChange={handleInputChange}
                                    pattern="^[0-9]{2}/[0-9]{4}"
                                    autoComplete="new-password"
                                    lable={"Valid Through"}
                                  />
                                  <small className="text-danger">{carderror.dates}</small>
                                </div>
                              </div>
                              {/* <!-- CVV  --> */}
                              <div className="col-12 col-sm-6 mt-2 mt-md-3">
                                <div className="form-group">
                                  <p className="brand-color3 text-left font-14 mb-2"> CVV </p>
                                  <input
                                    type="password"
                                    autoComplete="off"
                                    className="form-control"
                                    placeholder="eg. 1234"
                                    name='cvv'
                                    value={cardData.cvv}
                                    onChange={CardInputChange}
                                    maxLength={4}
                                  />
                                  <small className="text-danger">{carderror.cvv}</small>
                                </div>
                              </div>
                              <div class="col-12">
                                <input type="checkbox" checked={savecard === 1} onChange={(e) => SavecardHandeler(e)} /> Save Card
                              </div>
                              <div class="w-100 py-5 text-center">
                                <button type="button" class="btn btn-blue-grad px-4 w-50 text-capitalize mb-0 mb-md-5"
                                  onClick={() => paymentHandler(productDetail)}
                                > Proceed to pay </button>
                              </div>
                              {/* <!-- end of button and view policy --> */}

                            </div>
                          </form>
                        }
                      </div>
                    </div>
                  }
                  {/* <!-- end of col-md-6 --> */}
                </div>
                {/* <!-- end of row --> */}
              </div>
              {/* <!-- end of s-d-appoint-block --> */}
            </div>
            {/* <!-- end of s-d-appoint --> */}

          </div>
          {/* <!-- end of container --> */}
        </div>
        {/* <!-- End of My Studio Card Detials-Service Section --> */}

        {/* Discount Model Start */}
        <Modal
          show={showCodeModel.visible}
          onHide={() => { setShowCodeModel({ visible: false }) }}
          backdrop="static"
          centered
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Coupons Codes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(showCodeModel?.list ?? []).map((item, index) => (
              <div className="row discount_model_row" key={index}>
                <div className="col-md-9 m-auto">
                  <p className="m-0 p-0"> {item?.code_name}</p>
                </div>
                <div className="col-md-3  m-auto model_button_box">
                  <button
                    className="discount-button"
                    onClick={() => { onApplyDiscount(item) }}
                  >Apply</button>
                </div>
              </div>
            ))}
            {showCodeModel?.list?.length === 0 &&
              <div className="row discount_model_row">
                <div className="col-md-12 discount-box">
                  <p className="m-0 p-0"> No Coupon Available</p>
                </div>
              </div>
            }
          </Modal.Body>
        </Modal >
        {/*  Discount Model @End */}


        {/* <!-- CHECKOUT MODAL POPUP --> */}
        <Modal show={modalshow} class="modal fade" >

          <div class="modal-body border-radius6 box-shadow1 p-5 white-bg" >
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setModalshow(false)}>
              <span aria-hidden="true" style={{ fontSize: '40px', marginRight: '10px' }}>&times;</span> {/* This is the close icon */}
            </button>
            <div class="border-radius6 box-shadow-blue blue-gradient py-5 px-4 text-center">
              <img src="clientassets/img/logo_white.png" alt='' class="img-fluid" />
              <h4 class="title white-color text-capitalize my-4 font-w-600"> select checkout <br /> option </h4>
              {businessDetail.isCloverPurchase &&
                <button data-dismiss="modal" type="button" class="btn btn-white2 text-capitalize w-100 mb-4"
                  onClick={() => { setModalshow(false); setPaymentval(true); }}
                > pay now </button>}
              <button data-dismiss="modal" type="button" class="btn btn-white2 text-capitalize w-100"
                onClick={() => { setModalshow(false); PayAtStudio(); }}
              > pay on pick up </button>
            </div>
          </div>
        </Modal>
        {/* <!-- END OF CHECKOUT MODAL POPUP --> */}
      </div>
      <Innerfooter />

    </>
  )
}
